import { CurriculumDisicplineTypes } from "utils/constants";

// Required electives belong here too, but the API sends no flag — every elective is disciplineType
const belongsInMainTable = row =>
  row?.disciplineType === CurriculumDisicplineTypes.Regular ||
  row?.disciplineType === CurriculumDisicplineTypes.Cyclic;

// Same semester/course identity buildTabsAndData uses, so the flat tables land on the same tab.
const courseFromSemester = semester => {
  const sem = Number(semester);
  return sem > 0 ? Math.ceil(sem / 2) : null;
};

// The response carries no id, and react-admin keys Datagrid rows by one. Course is derived here
// because relocated rows lose the semester key; `-1` rows have no semester, so they keep theirs.
const withRowIdAndCourse = (row, semester) => ({
  ...row,
  id: row.id ?? `${semester}-${row.disciplineId}`,
  course: courseFromSemester(semester) ?? row.course,
});

export const splitGradesByType = (gradesBySemester = {}) => {
  const mainBySemester = {};
  const electiveTableRows = [];
  const facultativeTableRows = [];

  Object.entries(gradesBySemester).forEach(([semester, rows]) => {
    const kept = [];

    (rows ?? []).forEach(row => {
      const rowWithId = withRowIdAndCourse(row, semester);

      if (belongsInMainTable(row)) {
        kept.push(rowWithId);
        return;
      }

      switch (row?.disciplineType) {
        case CurriculumDisicplineTypes.Elective:
          electiveTableRows.push(rowWithId);
          break;
        case CurriculumDisicplineTypes.Facultative:
          facultativeTableRows.push(rowWithId);
          break;
        default:
          // Unknown type — keep it visible rather than filing it under the wrong heading.
          kept.push(rowWithId);
      }
    });

    // buildTabsAndData derives the tabs from these keys, so an empty one would advertise a semester
    // with no rows.
    if (kept.length > 0) mainBySemester[semester] = kept;
  });

  return { mainBySemester, electiveTableRows, facultativeTableRows };
};
